import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {combineLatest, Subject, Subscription} from "rxjs";
import {Store} from "@ngrx/store";
import * as fromStore from "../store";
import {filter, first, switchMap, takeUntil} from 'rxjs/operators';
import {UserSubscription, UserSubscriptionType} from "../user/user-subscription";
import {Website} from "../websites/website/website";
import {TypeUtils} from "../shared/utils/type-utils";
import {PaymentDialogComponent} from "../workspace/billing/payment-dialog/payment-dialog.component";
import {DialogService} from "../../ng2-bootstrap-modal/dialog.service";
import {Payment} from "../user/payment";

@Component({
    selector: 'db-recharge-header-banner',
    templateUrl: './recharge-header-banner.component.html',
    styleUrls: ['./recharge-header-banner.component.scss'],
    standalone: false
})
export class RechargeHeaderBannerComponent implements OnInit, OnDestroy {

  @ViewChild('mainHeaderContentHost') mainHeaderContentHost: ElementRef;

  private _subscriptions: Subscription[];
  public userSubscription: UserSubscription;
  public UserSubscriptionType: any = UserSubscriptionType;
  public paymentMethods: any;
  public stoppedWebsites: Website[];
  public payments: Payment[];
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _dialogService: DialogService
  ) {}

  ngOnInit() {
    this.addSubscriptions();
  }

  private addSubscriptions(): void {
    this._subscriptions = [];

    this._subscriptions.push(
      this._store.select(fromStore.getUserLoaded)
        .pipe(
          filter((loaded: boolean) => loaded),
          switchMap(() => combineLatest(
            this._store.select(fromStore.getUserSubscription),
            this._store.select(fromStore.getPayments)
          )),
          filter(([user, _]) => !!user),
          takeUntil(this._destroyStream$)
        )
        .subscribe(([userSubscription, payments]) => {
          this.userSubscription = userSubscription;
          this.payments = payments ? payments.filter(payment => payment.paymentStatus === 'Confirmed') : [];
        })
    );
    this._subscriptions.push(
      this._store.select(fromStore.getWebsitesLoaded)
        .pipe(
          filter((loaded: boolean) => loaded),
          switchMap(() => this._store.select(fromStore.getStoppedWebsites)),
          first()
        )
        .subscribe((data: any) => {
          this.stoppedWebsites = data;
        })
    );
  }

  ngOnDestroy() {

    this.removeSubscriptions();
  }


  private removeSubscriptions(): void {
    this._subscriptions.forEach((subscription: Subscription): void => {
      subscription.unsubscribe();
    });
    this._subscriptions = null;
  }

  private _getPaymentMethods(): void {
    this._store.select(fromStore.getUserPaymentMethodsLoaded)
      .pipe(
        switchMap(() => this._store.select(fromStore.getUserPaymentMethods))
      )
      .subscribe(data => {
        if (data && !TypeUtils.isNull(data)) {
          this.paymentMethods = data;
        }
      });
  }

  public renewUserSubscription(renew: boolean = false): void {
    this._dialogService
      .addDialog(PaymentDialogComponent, {
        upgradeSubscription: this.userSubscription,
        fromDialog: false,
        renew: true,
        activate: !renew,
        renewCouponCode: this.userSubscription && this.userSubscription.platformPaidClient && (!this.payments || this.payments.length === 0) && this.userSubscription.isExpired ? 'BLK50' : this.userSubscription && this.userSubscription.trialClient && this.userSubscription.isExpired ? 'BLK50OFF' : ''
      })
      .subscribe((reopenLast: boolean): void => {
        if (reopenLast) {
          this._store.dispatch(new fromStore.UpdateUserSubscription());
          this._store.dispatch(new fromStore.LoadUserLocalStorage());
          this._store.dispatch(new fromStore.LoadUserPayments());
        }
      });
  }

}
